// Configuración de idiomas por ruta
export const languageRestrictions = {
  // Rutas que NO tienen versión en japonés (excluye todas las subrutas)
  excludeJapanese: [
    '/trading/',
    '/partners/',
    '/company/careers/',
    '/company/facts-policy/',
    '/services/',
    '/forms-and-documents/',
    '/surfs-up/',
    '/contact-us/',
    '/faq/',
    '/privacy-policy-tvm/'
  ],
  // Rutas específicas que SÍ tienen versión en japonés (excepciones)
  includeJapanese: [
    '/trading/platforms/metatrader4/',
    '/trading/platforms/metatrader5/',
    '/trading/platforms/ctrader/',
    '/services/multimam/'
  ],
}

export const getExcludedJapaneseRoutes = (allRoutes) => {
    const excluded = []
  
    for (const route of allRoutes) {
      const isExcluded = languageRestrictions.excludeJapanese.some(ex => route.startsWith(ex))
      const isIncluded = languageRestrictions.includeJapanese.some(inc => route.startsWith(inc))
  
      if (isExcluded && !isIncluded) {
        excluded.push(`/ja${route}`)
      }
    }
  
    return excluded
  }

// Función para obtener idiomas disponibles según la ruta
export const getAvailableLanguages = (currentPath, allLanguages) => {
  let filteredLanguages = [...allLanguages]
  
  const isExcluded = languageRestrictions.excludeJapanese.some(route => currentPath.includes(route))
  
  const isIncluded = languageRestrictions.includeJapanese.some(route => currentPath.includes(route))
  
  if (isExcluded && !isIncluded) {
    filteredLanguages = filteredLanguages.filter(lang => lang.value !== 'ja')
  }
  
  return filteredLanguages
}

// FUNCIÓN CORREGIDA
export const shouldNoIndexRoute = (currentPath) => {
    // 1. Primero, verifica si la ruta es de la versión en japonés.
    // Si la ruta no comienza con '/ja', no hagas nada y permite la indexación.
    if (!currentPath.startsWith('/ja')) {
      return false;
    }
  
    // 2. Si la ruta SÍ es en japonés, aplica la lógica que ya tenías.
    const isExcluded = languageRestrictions.excludeJapanese.some(route => 
      currentPath.includes(route)
    );
    
    const isIncluded = languageRestrictions.includeJapanese.some(route => 
      currentPath.includes(route)
    );
  
    // Devuelve 'true' (noindex) solo si la ruta japonesa está en la lista de exclusión
    // y NO está en la lista de excepciones (inclusión).
    return isExcluded && !isIncluded;
  }

  